"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import useRevealOnScroll from "../../hooks/useRevealOnScroll";
import "./DifferentCategorySection.css";

export default function DifferentCategorySection() {
  const { t } = useTranslation("landingPage");

  useRevealOnScroll();

  const cardsRaw = t("different.cards", { returnObjects: true });
  const cards = Array.isArray(cardsRaw) ? cardsRaw : [];

  if (!cards.length) {
    return null;
  }

  return (
    <section className="dcs">
      <div className="dcs__container">
        <div className="dcs__header reveal-on-scroll reveal-up">
          <p className="dcs__eyebrow">{t("different.label")}</p>

          <h2 className="dcs__title">
            {t("different.title.line1")}
            <br />
            <span className="dcs__title-blue">
              {t("different.title.line2")}
            </span>
          </h2>

          <p className="dcs__subtitle">{t("different.subtitle")}</p>
        </div>

        <div className="dcs__grid">
          {cards.map((card, i) => (
            <div
              key={i}
              className="dcs__card reveal-on-scroll reveal-card"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <span className="dcs__tag">{card.tag}</span>
              <h3 className="dcs__card-title">{card.title}</h3>
              <p className="dcs__card-desc">{card.desc}</p>
            </div>
          ))}
        </div>

        <div className="dcs__cta-row reveal-on-scroll reveal-up">
          <button className="dcs__cta" type="button">
            {t("common.getStarted")}
            <span className="dcs__cta-icon">↗</span>
          </button>
        </div>
      </div>
    </section>
  );
}